/* AmaxBot chat widget for hydeline.com
 * Talks to https://reports.amaxleather.com/api/public/hydeline-chat
 * Self-contained — no jQuery/framework deps. */
(function () {
  if (window.__amaxbotLoaded) return;
  window.__amaxbotLoaded = true;

  var API_BASE = "https://reports.amaxleather.com";
  var SESSION_KEY = "amaxbot_session_id";
  var GREETING = "Welcome to Hydeline. I can help you find a piece, check stock, track an order, or explain our shipping, returns and leather care.\n\nFor an order, send me the order number and the email used at checkout.";

  function $(sel, root) { return (root || document).querySelector(sel); }
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) e.setAttribute(k, attrs[k]);
    if (html != null) e.innerHTML = html;
    return e;
  }
  function escapeHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
  }
  // Product photos + shop links. Reply text comes from an LLM, so it is ESCAPED
  // first and only OUR hosts may become <img>/<a> — anything else stays inert
  // text (blocks tracking pixels and phishing links from model output).
  var IMG_HOST = /^https:\/\/(cdn\.shopify\.com\/|file\.amax-asia\.com(:\d+)?\/|([\w-]+\.)*amaxleather\.com\/api\/public\/(hydeline-photo\?|p\/))/i;
  // gomwd.com = Metropolitan Warehouse & Delivery, our delivery partner's
  // customer tracking portal — the link track_shipment hands back.
  var LINK_HOST = /^https:\/\/([\w-]+\.)*(hydeline\.com|amaxleather\.com|gomwd\.com)(\/|$)/i;
  function isImgUrl(u) {
    return IMG_HOST.test(u) && (/\.(jpe?g|png|webp)(\?|$)/i.test(u) || /hydeline-photo\?|\/api\/public\/p\//i.test(u));
  }
  function linkify(s) {
    return escapeHtml(s).replace(/(https?:\/\/[^\s<]+)/g, function (u) {
      if (!LINK_HOST.test(u.replace(/&amp;/g, "&"))) return u;
      return '<a href="' + u + '" target="_blank" rel="noopener">' + u + '</a>';
    });
  }
  // "…/search?q=Paramount" → "Paramount", so the link reads as the piece the
  // shopper asked about instead of five identical "View on hydeline.com" rows.
  function linkLabel(url) {
    if (/gomwd\.com/i.test(url)) return "Track your delivery";
    var m = /[?&]q=([^&]+)/.exec(url);
    if (m) {
      try {
        var name = decodeURIComponent(m[1].replace(/\+/g, " ")).trim();
        if (name && name.length <= 40) return "View " + name;
      } catch (_) {}
    }
    return "View on hydeline.com";
  }
  function renderRich(container, text) {
    var seen = {}, shown = 0;
    // Photos are emitted right after the product they belong to, so render them
    // INLINE at that position — appending them all at the end orphaned every
    // picture from its product.
    function imgTag(url) {
      if (seen[url] || shown >= 3) return "";
      seen[url] = 1; shown++;
      return '<img src="' + escapeHtml(url) + '" alt="Product photo" loading="lazy" class="amx-photo"' +
             ' onerror="this.remove()">';
    }
    // Strip markdown first so brackets don't survive as literal text.
    var src = String(text == null ? "" : text)
      .replace(/!\[[^\]]*\]\((https?:\/\/[^\s)]+)\)/g, function (m, u) {
        return isImgUrl(u) ? "{{IMG:" + u + "}}" : m;
      })
      .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, function (_m, label, u) { return label + " " + u; });

    var html = escapeHtml(src).replace(/(https?:\/\/[^\s<)"']+)/g, function (raw) {
      var url = raw.replace(/&amp;/g, "&");
      if (isImgUrl(url)) return "{{IMG:" + url + "}}";
      if (LINK_HOST.test(url)) {
        return '<a href="' + escapeHtml(url) + '" target="_blank" rel="noopener noreferrer">' +
               escapeHtml(linkLabel(url)) + '</a>';
      }
      return raw;
    });
    html = html.replace(/\n{3,}/g, "\n\n").replace(/\n/g, "<br>");
    // Swap the placeholders for real <img> tags (src already host-allowlisted).
    html = html.replace(/\{\{IMG:([^}]+)\}\}/g, function (_m, u) {
      return imgTag(u.replace(/&amp;/g, "&"));
    });
    container.innerHTML = html;
  }
  function getSession() {
    try { return localStorage.getItem(SESSION_KEY) || ""; } catch (_) { return ""; }
  }
  function setSession(id) {
    try { localStorage.setItem(SESSION_KEY, id); } catch (_) {}
  }

  // ── Build DOM ─────────────────────────────────────────────────
  var root = el("div", { id: "amaxbot-root" });
  var launcher = el("button", {
    id: "amaxbot-launcher", "aria-label": "Open chat", type: "button", "class": "amx-pulse"
  },
    '<svg class="amx-ico-chat" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M21 11.5a8.4 8.4 0 0 1-9 8.4 9.6 9.6 0 0 1-2.6-.3L4 21l1.3-3.9A8.2 8.2 0 0 1 3 11.5 8.4 8.4 0 0 1 12 3a8.4 8.4 0 0 1 9 8.5z"/>' +
      '<path d="M8.5 11.5h.01M12 11.5h.01M15.5 11.5h.01"/>' +
    '</svg>' +
    '<svg class="amx-ico-close" viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>');

  var panel = el("div", { id: "amaxbot-panel", role: "dialog", "aria-modal": "false", "aria-label": "Chat with Hydeline" });
  panel.appendChild(el("div", { id: "amaxbot-head" },
    '<div class="amx-brand">' +
      '<div class="amx-seal" aria-hidden="true">H</div>' +
      '<div>' +
        '<div class="t">Hydeline</div>' +
        '<div class="s"><span class="amx-dot"></span> Concierge &middot; online</div>' +
      '</div>' +
    '</div>' +
    '<button id="amaxbot-close" aria-label="Close chat" type="button">&#10005;</button>'));
  var msgs = el("div", { id: "amaxbot-msgs", role: "log", "aria-live": "polite" });
  panel.appendChild(msgs);
  var chips = el("div", { id: "amaxbot-chips" });
  panel.appendChild(chips);
  var inputBar = el("div", { id: "amaxbot-input" });
  inputBar.appendChild(el("textarea", { rows: "1", placeholder: "Ask about a piece, an order…", "aria-label": "Message" }));
  inputBar.appendChild(el("button", { type: "button", "aria-label": "Send message" },
    '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 12h15M13 6l6 6-6 6"/></svg>'));
  panel.appendChild(inputBar);
  panel.appendChild(el("div", { id: "amaxbot-foot" },
    'Powered by AmaxBot &middot; <a id="amaxbot-human" role="button" tabindex="0">Talk to a human</a>'));

  root.appendChild(launcher);
  root.appendChild(panel);
  document.body.appendChild(root);

  var ta = $("textarea", inputBar);
  var sendBtn = $("button", inputBar);

  // Opening prompts — one tap each, so a visitor never faces a blank box.
  var QUICK = [
    "Track my order",
    "Help me find a recliner",
    "Shipping & returns",
    "Talk to a human"
  ];
  function showChips() {
    chips.innerHTML = "";
    QUICK.forEach(function (label) {
      var c = el("button", { "class": "amx-chip", type: "button" }, escapeHtml(label));
      c.addEventListener("click", function () {
        if (label === "Talk to a human") { clearChips(); humanLink.click(); return; }
        clearChips();
        ta.value = label;
        send();
      });
      chips.appendChild(c);
    });
  }
  function clearChips() { chips.innerHTML = ""; }

  // ── Render helpers ────────────────────────────────────────────
  function addMsg(role, text) {
    var m = el("div", { "class": "amx-msg " + (role === "user" ? "u" : "a") });
    var b = el("div", { "class": "b" });
    renderRich(b, text);
    m.appendChild(b);
    msgs.appendChild(m);
    msgs.scrollTop = msgs.scrollHeight;
    return m;
  }
  function addTyping() {
    var m = el("div", { "class": "amx-msg a", id: "amx-typing" });
    m.appendChild(el("div", { "class": "b" }, '<span class="amx-typing"><span></span><span></span><span></span></span>'));
    msgs.appendChild(m);
    msgs.scrollTop = msgs.scrollHeight;
    return m;
  }
  function removeTyping() {
    var t = document.getElementById("amx-typing");
    if (t) t.parentNode.removeChild(t);
  }
  // Centered status line — "connecting…", "Alec joined", chat closed.
  function addSystem(text) {
    var m = el("div", { "class": "amx-sys" });
    m.textContent = text;
    msgs.appendChild(m);
    msgs.scrollTop = msgs.scrollHeight;
    return m;
  }

  // ── Live agent mode (/livechat console) ───────────────────────
  // When a colleague is Online in reports.amaxleather.com/livechat, "Talk to a
  // human" hands the visitor to them and the bot steps aside; agent replies
  // arrive by polling. Nobody online → we fall through to HubSpot, then email.
  var liveMode = false;
  var lastPollId = 0;
  var pollTimer = null;
  function startPolling() {
    if (pollTimer) return;
    pollTimer = setInterval(pollOnce, 3500);
    pollOnce();
  }
  function stopPolling() { if (pollTimer) { clearInterval(pollTimer); pollTimer = null; } }
  function pollOnce() {
    var sid = getSession();
    if (!sid) return;
    fetch(API_BASE + "/api/public/hydeline-poll?sessionId=" + encodeURIComponent(sid) + "&after=" + lastPollId,
      { method: "GET", mode: "cors", credentials: "omit" })
      .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (data) {
        if (!data || !data.ok) return;
        // Agent closed the chat (or the queue timed out) → hand back to the bot.
        if (data.mode === "bot" || data.mode === "closed") { liveMode = false; stopPolling(); }
        (data.messages || []).forEach(function (m) {
          lastPollId = Math.max(lastPollId, m.id);
          if (m.sender === "agent") addMsg("assistant", m.body);
          else if (m.sender === "system") addSystem(m.body);
        });
      })
      .catch(function () {});
  }

  // ── Open / close ──────────────────────────────────────────────
  var opened = false;
  function open() {
    panel.classList.add("open");
    root.classList.add("amx-open");
    launcher.classList.remove("amx-pulse");
    launcher.setAttribute("aria-label", "Close chat");
    // next frame so the entrance transition actually runs
    requestAnimationFrame(function () { panel.classList.add("shown"); });
    if (!opened) {
      opened = true;
      addMsg("assistant", GREETING);
      setTimeout(showChips, 420);
    }
    setTimeout(function () { ta.focus(); }, 260);
    if (liveMode) startPolling(); // resume an agent conversation still in progress
  }
  function close() {
    stopPolling(); // don't poll a hidden panel; open() resumes it
    panel.classList.remove("shown");
    root.classList.remove("amx-open");
    launcher.setAttribute("aria-label", "Open chat");
    setTimeout(function () {
      if (!panel.classList.contains("shown")) panel.classList.remove("open");
    }, 340);
  }
  launcher.addEventListener("click", function () {
    panel.classList.contains("shown") ? close() : open();
  });
  $("#amaxbot-close", panel).addEventListener("click", close);
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && panel.classList.contains("shown")) close();
  });

  // ── Send ──────────────────────────────────────────────────────
  function autoSize() {
    ta.style.height = "auto";
    ta.style.height = Math.min(96, ta.scrollHeight) + "px";
    ta.style.overflowY = ta.scrollHeight > 96 ? "auto" : "hidden";
  }
  ta.addEventListener("input", autoSize);
  ta.addEventListener("keydown", function (e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  });
  sendBtn.addEventListener("click", send);

  function send() {
    var text = ta.value.trim();
    if (!text) return;
    clearChips();
    addMsg("user", text);
    ta.value = "";
    autoSize();

    // Live mode: the message goes to the human agent, not the bot — no typing
    // indicator, their reply arrives on the next poll.
    if (liveMode) {
      fetch(API_BASE + "/api/public/hydeline-chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sessionId: getSession(), message: text }),
        mode: "cors",
        credentials: "omit"
      }).catch(function () {});
      ta.focus();
      return;
    }

    sendBtn.disabled = true;
    var typing = addTyping();

    fetch(API_BASE + "/api/public/hydeline-chat", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sessionId: getSession(), message: text }),
      mode: "cors",
      credentials: "omit"
    }).then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .then(function (data) {
        removeTyping();
        if (data && data.ok && data.mode === "live") {
          // An agent claimed the chat between messages — let polling drive it.
          if (data.sessionId) setSession(data.sessionId);
          liveMode = true;
          startPolling();
        } else if (data && data.ok) {
          if (data.sessionId) setSession(data.sessionId);
          addMsg("assistant", data.reply || "(no reply)");
        } else {
          addMsg("assistant", "Sorry — I hit a snag reaching the server. Please try again, or click 'Talk to a human' below.");
        }
      })
      .catch(function () {
        removeTyping();
        addMsg("assistant", "Connection error. Please try again, or click 'Talk to a human' below.");
      })
      .then(function () { sendBtn.disabled = false; ta.focus(); });
  }

  // ── Talk-to-a-human escalation (inline form) ──────────────────
  var SUPPORT_EMAIL = "customerservice@hydeline.com";
  var humanLink = $("#amaxbot-human", panel);

  humanLink.addEventListener("keydown", function (e) {
    if (e.key === "Enter" || e.key === " ") { e.preventDefault(); humanLink.click(); }
  });
  // "Talk to a human" cascade, best option first:
  //   1. our own /livechat console, when a colleague is toggled Online there —
  //      the conversation stays in this window and we keep the full transcript
  //   2. HubSpot chat — CS's existing inbox, so it lands where they already work
  //   3. the email follow-up form — always available, never a dead end
  humanLink.addEventListener("click", function () {
    if (document.getElementById("amx-esc-form")) return;
    if (liveMode) { addSystem("You're already connected with our team."); return; }

    // request-human needs a real session id; a visitor who clicks this first
    // hasn't got one yet, so mint it here (the server accepts a client uuid).
    var sid = getSession();
    if (!sid) {
      sid = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
        : "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0;
            return (c === "x" ? r : ((r & 0x3) | 0x8)).toString(16);
          });
      setSession(sid);
    }

    var typing = addTyping();
    fetch(API_BASE + "/api/public/hydeline-request-human", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ sessionId: sid }),
      mode: "cors",
      credentials: "omit"
    }).then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
      .catch(function () { return { ok: false }; })
      .then(function (data) {
        removeTyping();
        if (data && data.ok && data.live) {
          liveMode = true;
          addSystem("Connecting you with a Hydeline team member… one moment.");
          startPolling();
          return;
        }
        handoffToHubSpot();
      });
  });

  // Nobody staffing our console → HubSpot chat, else the email form.
  function handoffToHubSpot() {
    var hs = window.AmaxHubSpotChat;
    if (hs && hs.present()) {
      addMsg("assistant", "Connecting you with our team…");
      hs.open(4000).then(function (opened) {
        if (opened) { close(); return; }
        addMsg("assistant", "Our live chat isn't answering right now — leave your email instead and the team will follow up.");
        showEscalationForm();
      });
      return;
    }
    showEscalationForm();
  }

  function showEscalationForm() {
    var sessionId = getSession();
    if (!sessionId) {
      addMsg("assistant", "Send a message first so I have something to forward to our team.");
      return;
    }
    if (document.getElementById("amx-esc-form")) return; // already showing

    var wrap = el("div", { "class": "amx-msg a", id: "amx-esc-form" });
    var bubble = el("div", { "class": "b" },
      '<div class="amx-esc-title">Let’s get you a person</div>' +
      '<div style="margin-bottom:10px;font-size:13.5px;color:#6b625b">Leave your email and our team will pick this up.</div>' +
      '<input type="email" class="amx-esc-email" placeholder="you@email.com" aria-label="Your email">' +
      '<input type="text" class="amx-esc-note" placeholder="Anything to add? (optional)" aria-label="Optional note">' +
      '<button type="button" class="amx-esc-send">Request follow-up</button>');
    wrap.appendChild(bubble);
    msgs.appendChild(wrap);
    msgs.scrollTop = msgs.scrollHeight;

    var emailInput = $(".amx-esc-email", bubble);
    var noteInput = $(".amx-esc-note", bubble);
    var submitBtn = $(".amx-esc-send", bubble);
    emailInput.focus();

    submitBtn.addEventListener("click", function () {
      var email = emailInput.value.trim();
      if (!/^[\w.+-]+@[\w-]+\.[\w.-]+$/.test(email)) {
        emailInput.style.borderColor = "#c0392b";
        emailInput.focus();
        return;
      }
      submitBtn.disabled = true;
      submitBtn.textContent = "Sending…";
      fetch(API_BASE + "/api/public/hydeline-escalate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ sessionId: sessionId, email: email, message: noteInput.value.trim() }),
        mode: "cors",
        credentials: "omit"
      }).then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (data) {
          wrap.parentNode.removeChild(wrap);
          if (data && data.ok) {
            addMsg("assistant", "Thanks — our team will follow up with you at " + email + " as soon as possible.");
          } else {
            addMsg("assistant", "Sorry, that didn't go through. Please email us directly at " + SUPPORT_EMAIL + ".");
          }
        })
        .catch(function () {
          wrap.parentNode.removeChild(wrap);
          addMsg("assistant", "Connection error. Please email us directly at " + SUPPORT_EMAIL + ".");
        });
    });
    emailInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); submitBtn.click(); }
    });
    noteInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); submitBtn.click(); }
    });
  }
})();
